import React from 'react'
import PropTypes from 'prop-types'
import GoogleAnalytics from 'react-ga'
import {withRouter} from 'react-router'

const enableTracking = !!window.ENV.GA_ID
if (enableTracking) {
  GoogleAnalytics.initialize(window.ENV.GA_ID)
}

class GAListener extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired
  }

  componentDidMount() {
    this.sendPageView(this.props.history.location)
    this.props.history.listen(this.sendPageView)
  }

  sendPageView(location) {
    if (enableTracking) {
      const page = `${location.pathname}${location.search}`
      GoogleAnalytics.set({page})
      GoogleAnalytics.pageview(page)
    }
  }

  render() {
    return this.props.children
  }
}

export default withRouter(GAListener)
